import { forwardRef, HTMLProps } from 'react'

type Props = {
  options: HTMLProps<HTMLOptionElement>[]
}
type SelectProps = HTMLProps<HTMLSelectElement>

const Select = forwardRef<HTMLSelectElement, Props & SelectProps>(
  ({ className, label, id, options, placeholder, ...rest }, ref) =>{

    return (
      <div className={`mb-2 w-full ${className}`}>
        <label htmlFor={id} data-content={label} className="font-semibold text-sm">
          {label}
        </label>
        <select
          id={id}
          className={
            `flex items-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-2 py-2 mt-1 justify-between text-muted-foreground w-full`}
          ref={ref}
          {...rest}
        >
          <option disabled key="placeholder" value="">
            {placeholder}
          </option>
          {options.map(({ value, children }) => (
            <option key={`option_${value}`} value={value}>
              {children}
            </option>
          ))}
        </select>
      </div>
    )
  }
)

export default Select
